import { CircleAlert, Check } from 'lucide-react';
import { Toaster as SonnerToaster } from 'sonner';

/**
 * TDS toast — grey-900 표면 + 흰 라벨, radius 14, shadow-toast.
 * 성공 아이콘은 20px green 원 + 흰 체크. 모바일은 하단 탭바 위에 뜨도록 여백을 둔다.
 */
export function Toaster() {
  return (
    <SonnerToaster
      position='bottom-center'
      offset={24}
      mobileOffset={{ bottom: 104 }}
      duration={3000}
      icons={{
        success: (
          <span className='flex size-5 items-center justify-center rounded-full bg-fill-success'>
            <Check className='size-3.5 text-fg-inverse' strokeWidth={3} />
          </span>
        ),
        error: <CircleAlert className='size-5 text-fg-danger' />,
      }}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex w-full items-center gap-3 rounded-l bg-fill-primary px-5 py-4 text-label-m text-fg-inverse shadow-toast sm:w-[360px]',
          title: 'font-semibold',
          description: 'text-body-3 text-inverse-fg-secondary',
          actionButton:
            'ml-auto shrink-0 rounded-s px-2 py-1 text-label-s text-fg-inverse hover:bg-inverse-fill-hover',
        },
      }}
    />
  );
}
